import React, { createContext } from 'react'

const StockContext = createContext()
export default StockContext
